import { customElement, property } from "lit/decorators.js";
import { SearchBaseComponent } from "./SearchBaseComponent";
import { html, TemplateResult } from "lit";
import { SearchRequest } from "../../openApiClients/generated/EngineeringUK.Sites";

@customElement("euk-search-reset-filters")
export class SearchResetFiltersComponent extends SearchBaseComponent {
  @property({ type: Object })
  request?: SearchRequest;

  private resetFilters() {
    if (!this.request) {
      return;
    }
    this.request.filters?.forEach((filter) => {
      filter.options?.forEach(option => (option.selected = false));
    });
    this.request.page = 1;

    this.triggerEvent(this.request ?? {}, this.requestUpdateEvent);

    document.querySelector(".js-filters")?.classList.remove("active");
  }

  render(): TemplateResult<1> {
    return html` ${super.render()}
      <button
        @click="${this.resetFilters}"
        class="filters__reset-btn unbutton"
        type="button"
      >
        Reset all
      </button>`;
  }
}
